import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
// The Almikia gradient mark reads on the navy header in both themes.
import almikiaMark from "./logos/almikia_mark.png";

export const defaultDarkModeLogo = almikiaMark;
export const defaultLightModeLogo = almikiaMark;

export const defaultCurrency = "MXN";

export const defaultTitle = "Almikia CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Servicios de comunicación" },
  { value: "consumer-discretionary", label: "Consumo discrecional" },
  { value: "consumer-staples", label: "Consumo básico" },
  { value: "energy", label: "Energía" },
  { value: "financials", label: "Servicios financieros" },
  { value: "health-care", label: "Salud" },
  { value: "industrials", label: "Industria" },
  { value: "information-technology", label: "Tecnologías de la información" },
  { value: "materials", label: "Materiales" },
  { value: "real-estate", label: "Bienes raíces" },
  { value: "utilities", label: "Servicios públicos" },
];

// Almikia lead pipeline states, in pipeline order (Almikia Epic E2).
// `stages.ts` is the single shared source of truth for the state partitions
// (kanban columns, special states, inbox state, POSI-gated states); this
// list only adds the Spanish (Mexico) labels shown in the UI.
export const defaultDealStages = [
  { value: "prospecto", label: "Prospecto" },
  { value: "contacto_inicial", label: "Contacto inicial" },
  { value: "discovery", label: "Discovery" },
  { value: "showing", label: "Showing" },
  { value: "cierre", label: "Cierre" },
  { value: "administracion", label: "Administración" },
  { value: "venta_cerrada", label: "Venta cerrada" },
  { value: "cerrado_perdido", label: "Cerrado perdido" },
  { value: "codigo_azul", label: "Código Azul" },
  { value: "seguimiento_futuro", label: "Seguimiento futuro" },
];

export const defaultDealPipelineStatuses = ["venta_cerrada"];

export const defaultDealCategories = [
  { value: "other", label: "Otra" },
  { value: "copywriting", label: "Redacción" },
  { value: "print-project", label: "Proyecto impreso" },
  { value: "ui-design", label: "Diseño de interfaz" },
  { value: "website-design", label: "Diseño web" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frío", color: "#a9abbc" },
  { value: "warm", label: "Tibio", color: "#f5e170" },
  { value: "hot", label: "Caliente", color: "#df836d" },
  { value: "in-contract", label: "En contrato", color: "#ca6da0" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Ninguna" },
  { value: "email", label: "Correo" },
  { value: "demo", label: "Demostración" },
  { value: "lunch", label: "Comida" },
  { value: "meeting", label: "Reunión" },
  { value: "follow-up", label: "Seguimiento" },
  { value: "thank-you", label: "Agradecimiento" },
  { value: "ship", label: "Envío" },
  { value: "call", label: "Llamada" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
